if (typeof window.dogBreedSelectorInitialized === "undefined") {
  window.dogBreedSelectorInitialized = true;

  function searchresultbreed(input) {
    let get_value = input.value.toLowerCase();
    let dropdown = input
      .closest(".suggestion-container")
      .querySelector(".dropdown-content");
    let breedLinks = dropdown.querySelectorAll(".option-list");

    breedLinks.forEach(function (breed) {
      let breed_html = breed.innerHTML.toLowerCase();
      breed.style.display = breed_html.includes(get_value) ? "block" : "none";
    });
  }

  let toggleDropdownBtn = document.querySelectorAll(
    ".suggestion-container .toggle-dropdown-btn"
  );
  let dropdownContent = document.querySelectorAll(
    ".suggestion-container .dropdown-content .option-list"
  );

  if (toggleDropdownBtn) {
    toggleDropdownBtn.forEach(function (btn) {
      btn.addEventListener("click", function () {
        let container = this.closest(".suggestion-container");
        let content_element = container.querySelector(".dropdown-content");

        content_element.classList.toggle("hide");

        if (!content_element.classList.contains("hide")) {
          let input = container.querySelector(".search-results-input");

          if (input) {
            input.focus();
          } else {
          }
        }
      });
    });
  }

  if (dropdownContent) {
    dropdownContent.forEach(function (breed) {
      breed.addEventListener("click", function () {
        let container = this.closest(".suggestion-container");

        let selected_breed = this.innerHTML;
        let selected_size = this.getAttribute("data-value");

        let content_element = container.querySelector(".dropdown-content");
        content_element.classList.add("hide");

        container.querySelector(".btn-changeable-text").innerHTML =
          selected_breed;

        let recommendationSection = container.querySelector(
          ".recommendation-section"
        );

        if (recommendationSection) {
          recommendationSection.classList.remove("hide");

          recommendationSection.querySelector(
            ".selected-value-title-phrase"
          ).innerHTML = "Voor jouw " + selected_breed + " raden wij aan:";

          recommendationSection.querySelector(".selected-value").innerHTML =
            selected_size;
        } else {
        }

        // ======================
        // Listicle button (NL only)
        // ======================
        let selectorCatButton = document.querySelector(".selector-cat-button");
        if (selectorCatButton) {
          selectorCatButton.classList.remove("hide");
        }

        let variantsSelector = null;

        // ======================
        // Find popup
        // ======================

        const popup = container.closest(".size-guide-popup");

        if (popup && popup.id) {
          const sectionId = popup.id.replace("sizeGuidePopup-", "");

          variantsSelector = document.querySelector(
            `product-info[data-section="${sectionId}"] .mff_variant-selects`
          );
        } else {
        }

        if (!variantsSelector) {
          const productInfo = container.closest("product-info");

          if (productInfo) {
            variantsSelector =
              productInfo.querySelector(".mff_variant-selects");
          } else {
          }
        }

        if (!variantsSelector) {
          variantsSelector = document.querySelector(".mff_variant-selects");
        }

        if (variantsSelector) {
          // NL keeps its own data-id ("Maat") — not changed to "Größe"
          let selectElement = variantsSelector.querySelector(
            '.mff_select__select[data-id="Maat"]:not([style*="display:none"])'
          );

          if (selectElement) {
            let matchingOption = Array.from(
              selectElement.options || []
            ).find((option) => {
              let optionSize = option.value
                .replace(/\(.*?\)/g, "")
                .split(/-|–|_/)[0]
                .trim();

              return (
                optionSize?.toLowerCase() === selected_size.toLowerCase()
              );
            });

            if (matchingOption) {
              selectElement.value = matchingOption.value;

              selectElement.dispatchEvent(
                new Event("change", {
                  bubbles: true,
                  cancelable: true,
                })
              );

              selectElement.dispatchEvent(
                new Event("input", {
                  bubbles: true,
                })
              );
            } else {
              if (recommendationSection) {
                recommendationSection.classList.remove("hide");

                recommendationSection.querySelector(
                  ".selected-value-title-phrase"
                ).innerHTML = `Voor jouw ${selected_breed}, geen overeenkomstig resultaat gevonden!`;

                recommendationSection.querySelector(
                  ".selected-value"
                ).innerHTML = "";
              }
            }
          }

          let radioInputs = variantsSelector.querySelectorAll(
            '.size_variant_box input[type="radio"]:not([style*="display:none"])'
          );

          if (radioInputs) {
            if (radioInputs.length > 0) {
              let matchingRadio = Array.from(radioInputs).find((input) => {
                let optionSize = input.value
                  .replace(/\(.*?\)/g, "")
                  .split(/-|–|_/)[0]
                  .trim()
                  .toLowerCase();

                return optionSize === selected_size.toLowerCase();
              });

              if (matchingRadio) {
                matchingRadio.click();

                matchingRadio.dispatchEvent(
                  new Event("change", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              } else {
                if (recommendationSection) {
                  recommendationSection.classList.remove("hide");

                  recommendationSection.querySelector(
                    ".selected-value-title-phrase"
                  ).innerHTML = `Voor jouw ${selected_breed}, geen overeenkomstig resultaat gevonden!`;

                  recommendationSection.querySelector(
                    ".selected-value"
                  ).innerHTML = "";
                }
              }
            } else {
            }
          }
        } else {
        }
      });
    });
  } else {
  }

  document.addEventListener("click", function (event) {
    document
      .querySelectorAll(".suggestion-container .dropdown-content")
      .forEach(function (dropdown) {
        if (!dropdown.closest(".suggestion-container").contains(event.target)) {
          dropdown.classList.add("hide");
        }
      });
  });
}